import PipelineNetwork from "./PipelineNetwork";
import { KonvaNode } from "./KonvaNode";
import ExampleStore from '@/component/ExampleStore';

const Test = () => {
    return (
      <div >
        <PipelineNetwork />
        <svg id="svgLogo1"
          width="980" height="580" viewBox="0 0 980 580"
          xmlns="http://www.w3.org/2000/svg">
          <filter id="particle-effect">
            <feTurbulence type="fractalNoise" baseFrequency="0.05" seed="2" numOctaves="2" result="turbulence" />
            <feDisplacementMap in2="turbulence" in="SourceGraphic" scale="50" xChannelSelector="R" yChannelSelector="G" />
          </filter>
          <g filter="url(#particle-effect)">
            <circle cx="250" cy="250" r="100" fill="none" stroke="red" stroke-width="4" />
            <circle cx="250" cy="250" r="10" fill="blue" />
            <circle cx="200" cy="200" r="10" fill="blue" />
            <circle cx="300" cy="300" r="10" fill="blue" />
            <circle cx="200" cy="300" r="10" fill="blue" />
            <circle cx="300" cy="200" r="10" fill="blue" />
          </g>
          <rect x="0" y="5" width="980" height="54" rx="6" ry="6" filter="url(#particle-effect)"
          />
  
        </svg>
        
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
          <defs>
            <filter id="f1" x="0" y="0" width="200%" height="200%">
              <feOffset result="offOut" in="SourceGraphic" dx="2" dy="2" />
              <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />
              <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
            </filter>
          </defs>
          <rect width="90" height="90" stroke="green" stroke-width="1"
            fill="gray" filter="url(#f1)" />
        </svg>
        <KonvaNode />
       
        <ExampleStore/>
      </div>
    );
  };

  
export default Test;
